import { DespachoAndamentoPk } from './../model/despacho-andamento-pk';
import { Injectable } from '@angular/core';
import { CsiHttp } from '../../core/csi-http';
import { environment } from '../../../environments/environment';
import { ConsultaDespachoRecurso } from '../../modulos/consulta-unificada/consultaunificada/entidades/consulta-despacho-recurso';

@Injectable()
export class SolicitacaoRecursoService {
  constructor(private http: CsiHttp) {}
  apiPrincipalURL = environment.principal;

  getColunasSolicitacaoRecurso(tela: string) {
    let url =
      this.apiPrincipalURL + '/solicitacaoRecurso/getColunasSolicitacaoRecurso';
    url += '?tela=' + tela;
    return this.http.get(url).map((response: any) => {
      return response;
    });
  }

  consultaDadosAtendimentoSamu( nrDdd: number, nrTelefone: number, nrChamado: number, nrDespacho: number ) {
    let url = this.apiPrincipalURL + '/solicitacaoRecurso/consultaDadosAtendimentoSamu';
    url += '?nrDdd=' + nrDdd + '&nrTelefone=' + nrTelefone + '&nrChamado=' + nrChamado + '&nrDespacho=' + nrDespacho ;
      return this.http.get(url)
                  .map(
                      (response: any) => {
                          return response;
                      }
                  );
  }

  solicitaRecursoSelecionado(recursoSelecionado: ConsultaDespachoRecurso, _idEnvDespachador: string) {
    const url = this.apiPrincipalURL + '/solicitacaoRecurso/solicitaRecursoSelecionado';
    return this.http.post(url, recursoSelecionado, _idEnvDespachador).map((response: any) => {
      return response;
    });
  }

  solicitaRecursoSelecionadoBv(recursoSelecionado: ConsultaDespachoRecurso, _idEnvDespachador: string) {
    const url = this.apiPrincipalURL + '/solicitacaoRecurso/solicitaRecursoSelecionadoBv';
    return this.http.post(url, recursoSelecionado, _idEnvDespachador).map((response: any) => {
      return response;
    });
  }

  removeRecursoSelecionadoBv(recursoSelecionado: ConsultaDespachoRecurso) {
    const url = this.apiPrincipalURL + '/solicitacaoRecurso/removeRecursoSelecionadoBv';
    return this.http.post(url, recursoSelecionado).map((response: any) => {
      return response;
    });
  }

  removeRecursoSelecionado(recursoSelecionado: ConsultaDespachoRecurso) {
    const url = this.apiPrincipalURL + '/solicitacaoRecurso/removeRecursoSelecionado';
    return this.http.post(url, recursoSelecionado).map((response: any) => {
      return response;
    });
  }

  verificaPossuiRespostaSecundaria(tpIncidente: String, despachoAndamentoPk: DespachoAndamentoPk) {
    let url = this.apiPrincipalURL + '/protocoloRM/verificaPossuiRespostaSecundaria';
    url += '?tpIncidente=' + tpIncidente + '&nrDDD=' + despachoAndamentoPk.nrDdd + '&nrTelefone=' + despachoAndamentoPk.nrTelefone ;
    url += '&nrChamado=' + despachoAndamentoPk.nrChamado + '&nrDespacho=' + despachoAndamentoPk.nrDespacho;
    return this.http.get(url).map((response: any) => {
      return response;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/commons/servicos/solicitacao-recurso.service.ts